import React from 'react';

const PlatformRatings = ({ art, fullMode = false }) => {
  const { otherPlatformInfos = [] } = art;

  const formatRating = (rating) => (rating === 0 ? '-' : rating.toFixed(1));
  const iconSizeClass = 
    fullMode
      ? "max-w-24 max-h-10"
      : "max-w-4 max-h-4 opacity-95";
  const textClass =
    fullMode
      ? "text-gray-300 text-sm font-medium leading-none"
      : "text-gray-400 text-[11px] font-medium leading-none";

  const getIconForName = (name) => {
    switch (name.toLowerCase()) {
      case 'imdb': return '/imdb_small_icon.png';
      case 'kinopoisk': return '/kinopoisk_small_icon.png';
      case 'applebooks': return '/applebooks_icon.png';
      case 'steam': return '/steam_icon.png';
      case 'rottentomatoes': return '/rottentomatoes_icon.png';
      case 'reddit': return '/reddit_icon.png';
      case 'amazon': return '/amazon_icon.png';
      case 'goodreads': return '/goodreads_icon.png';
      case 'metacritic': return '/metacritic_icon.png';
      case 'wikipedia': return '/wiki_icon.png';
      case 'litres': return '/litres_icon.png';
      case 'livelib': return '/livelib_icon.png';
      default: return null;
    }
  };

  const renderIconOrText = (icon, fullMode) => {
    if (icon === '/rottentomatoes_icon.png') {
      return (
        <span className="text-red-500 font-bold">
          {fullMode ? 'Rotten Tomatoes' : 'RT'}
        </span>
      );
    }
    const title = icon === '/metacritic_icon.png' ? 'For PC platform / Для ПК платформы' : '';
    const additionalClasses = icon === '/wiki_icon.png' ? 'bg-white rounded-md p-1' : '';
    return <img src={icon} title={title} className={`rounded-md ${iconSizeClass} ${additionalClasses}`} />;
  };

  return (
    <div className="flex justify-center items-center gap-1 text-xs font-medium leading-none opacity-95">
      {otherPlatformInfos.map(({ name, link, score, votes }) => {
        const icon = getIconForName(name);
        if (!icon) return null;
        if (!fullMode && (score === undefined || score === 0)) return null; // Skip unrated platforms in list view

        return (
          <div key={name} className="flex items-center space-x-0.5">
            {link ? (
              <a href={link} target="_blank" rel="noopener noreferrer">
                {renderIconOrText(icon, fullMode)}
              </a>
            ) : (
              renderIconOrText(icon, fullMode)
            )}
            {(score !== undefined && (fullMode || score !== 0)) && (
              <span className={textClass}>{formatRating(score)}</span>
            )}
            {fullMode && votes !== undefined && votes !== 0 && (
              <span className={`${textClass} text-gray-500`}> / {votes.toLocaleString()}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PlatformRatings;
